import { Directive, ElementRef, Renderer } from '@angular/core';

@Directive({
  selector: '[scroll-me]'
})
export class ScrollMeDirective {
  constructor(private elRef: ElementRef, private renderer: Renderer) {
    renderer.listen(elRef.nativeElement, 'wheel', (e) => {

      if (elRef.nativeElement.scrollTop + elRef.nativeElement.offsetHeight > elRef.nativeElement.scrollHeight) {
        if (e.deltaY > 0) {
          e = e || window.event;
          if (e.preventDefault) {
            e.preventDefault();
          }
          e.returnValue = false;
        }
      }
    });
  }
}
